import { render } from "./Profile.vue?vue&type=template&id=88b285ba&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=88b285ba&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3011205126/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88b285ba"]])

export default __exports__